import { Skeleton } from '@whistler-ui/k2/components/Skeleton';
import { Stack } from '@whistler-ui/k2/components/Stack';

const FieldSkeleton = () => {
  return (
    <Stack direction="column" gap={2} className="flex-1">
      <Skeleton width="50%" height={16} />
      <Skeleton width="100%" height={40} />
    </Stack>
  );
};

export const ImplementationStepsSkeleton = () => {
  return (
    <Stack
      direction="column"
      gap={8}
      className="flex-1"
      data-testid="implementation-steps-skeleton"
    >
      <Stack direction="column" gap={3}>
        <Skeleton width="40%" height={24} />
        <Skeleton width="65%" height={14} />
      </Stack>
      <Stack direction="row" gap={5}>
        <FieldSkeleton />
        <FieldSkeleton />
      </Stack>
      <Stack direction="row" gap={5}>
        <FieldSkeleton />
        <FieldSkeleton />
      </Stack>
      <Skeleton width="100%" height={160} />
      <Stack direction="row" justify="between" className="mt-auto">
        <Skeleton width={120} height={40} />
        <Skeleton width={120} height={40} />
      </Stack>
    </Stack>
  );
};
